export const SET_TEEUP_NAME = "SET_TEEUP_NAME"
export const SET_TEEUP_IMAGE = "SET_TEEUP_IMAGE"
export const SET_TEEUP_MESSAGE = "SET_TEEUP_MESSAGE"
export const SET_INVITEES = "SET_INVITEES"
export const SET_IS_INVITEES_OPEN = "SET_IS_INVITEES_OPEN"
// CREATE-COVER 2026-07-04: a real (manual) cover pick always wins and is never overridden.
// APPLY_AUTO_COVER is the ONE-TIME topic-aligned adjustment path (title-forms trigger); it only
// takes effect if the user hasn't manually picked a cover AND the auto-adjustment hasn't already
// fired once for this draft.
export const APPLY_AUTO_COVER = "APPLY_AUTO_COVER"
